// extracted by mini-css-extract-plugin
export default {"bannerContent":"bannerContent__1Nu7U","bold":"bold__35oYN"};